<template>
  <v-container mt-0 pb-0 pt-0 text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <span>ID : {{userinfo.email}}</span>
      </v-flex>
      <v-flex xs12>
        <span>Saved TimeStamp : {{ timestamp }}</span>
      </v-flex>
      <!-- <v-flex xs4>
        <v-btn @click="buildCookie()">
          setCookie2
        </v-btn>
      </v-flex>
      <v-flex xs8>
        <v-btn @click="getCookie('position_token')">
          getCookie
        </v-btn>
      </v-flex>
      <v-flex xs12>
        {{ cookie }}
      </v-flex> 
      <v-flex xs12>
        <v-text-field label="AccessKey" v-model="access_key" readonly></v-text-field>
      </v-flex> -->
      <v-flex xs12>
        <v-btn color="primary" @click="store_position()">Save</v-btn>
      </v-flex>
      <v-flex xs12>
        <transition name="fade">
          <div v-if="alert.is_visible">
            <v-alert
              :value="true"
              :type="alert.type"
              transition="scale-transition"
            >{{ alert.message }}</v-alert>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import sha256 from 'js-sha256';

export default {
  props: ["results_data", "userinfo", "position_list"],
  data() {
    return {
      alert: {
        is_visible: false,
        type: "success",
        message: "success"
      },
      cookie: 'empty',
      name: "test",
      access_key: "not generated",
      timestamp: ""
    };
  },

  methods: {
    makeGuestCookie() {
      var date = new Date();
      return sha256(date.getTime().toString());
    },
    setCookie(name, value, days) {
      console.log('setCookie');
      
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";

      console.log(this.$store.getters.getCookie('position_token'));
    },
    // getCookie(name) {
    //   var nameEQ = name + "=";
    //   var ca = document.cookie.split(";");
    //   for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
    //     if (c.indexOf(nameEQ) == 0){
    //       this.cookie = c.substring(nameEQ.length, c.length);
    //       console.log(this.cookie);
    //       return this.cookie;
    //     } 
        
    //   }
    //   return null;
    // },
    // buildCookie(){
    //   //console.log('buildCookie');
    //   var token = this.makeGuestCookie();
    //   //console.log(token);
    //   this.setCookie('position_token', token ,7);
    // },
    store_position() {
      var this_component = this;
      //console.log(this.position_list);

      if (this.position_list.length < 1) {
        this_component.alert.is_visible = true;
        this_component.alert.type = "warning";
        this_component.message = "position is empty";
      }

      var position_token = this.makeGuestCookie();
      this_component.setCookie('position_token', position_token, 7)

      this.$axios
        //.post("http://127.0.0.1:5000/storepositions", {
          .post(this.$store.state.url_end_point + "/storepositions", {
          
          email: this_component.$store.state.userinfo.email,
          position_token: position_token,
          results_data: this_component.$store.state.results_data,
          position_list: this.position_list
        })
        .then(function(response) {
          //console.log(response.data);
          var message = response.data["message"];

          if (message == "success") {
            this_component.position_stored = true;
            this_component.access_key = response.data["access_key"];
            
            //console.log(message);

            this_component.alert.is_visible = true;
            this_component.alert.type = "success";
            this_component.alert.message = message;
            this_component.timestamp = response.data["timestamp"];
          }
        })
        .catch(function(error) {
          this_component.alert.is_visible = true;
          this_component.alert.type = "error";
          this_component.alert.message = 'save fail';
          //console.log(error);
        });
    }
    
  }

};
</script>

<style>
</style>
